<script>
  import CatalogFliter from "@/components/CatalogFliter.vue";
  import RangeFilter from "@/components/RangeFilter.vue";
  import ajax from "@/util/ajax.js";

  export default {
    components: {
      CatalogFliter,
      RangeFilter,
    },
    props: {
      baseUrl: {
        type: String,
        requred: true,
      },
      filters: {
        type: Object,
        requred: true,
      },
      initalFilterValues: {
        type: Object,
        requred: true,
      },
      initalShownProducts: {
        type: Number,
        requred: true,
      },
      initalTotalProducts: {
        type: Number,
        requred: true,
      },
      colorGroups: {
        type: Array,
        default: () => ({}),
      },
      bottomText: {
        type: String,
      },
    },
    data() {
      return {
        filterValues: this.initalFilterValues,
        loading: false,
        isshowmore:false,
        products: [],
        shownProducts: this.initalShownProducts,
        totalProducts: this.initalTotalProducts,
        offset: 0,
      };
    },
    computed: {
      colorGroupIdByUrl() {
        return this.colorGroups.reduce((result, color) => {
          result[color.static_url] = parseInt(color.id);
          return result;
        }, {});
      },
    },
    methods: {
      async updateProducts() {
        const data = Object.assign(
                {
                  query: Object.assign(
                          {
                            offset: 0,
                            limit: 12,
                          },
                          this.filterValues
                  ),
                },
                Application.config
        );

        this.loading = true;
        const result = await ajax("/ajax/content/get_products.php", data);
        this.loading = false;
        this.offset = 0;
        // if (
        //         result &&
        //         result.result &&
        //         result.result === "success" &&
        //         result.products
        // ) {
        //   //this.products = /*[this.products, ...*/ result.products /*]*/;
        //   this.products = [...result.products]; // Используем оператор spread для создания нового массива
        //
        //   this.offset = this.products.length;
        //   this.shownProducts = this.products.length;
        //   console.log("results=",result.products);
        // }

        if (
                result &&
                result.result &&
                result.result === "success" &&
                result.products
        ) {
          this.products = [...result.products]; // Используем оператор spread для создания нового массива
          this.offset = this.products.length;
          this.shownProducts = this.products.length;
        }
      },
      async showMore() {
        const data = Object.assign(
                {
                  query: Object.assign(
                          {
                            offset: this.offset,
                            limit: this.products.length == 0 ? 24 : 12,
                          },
                          this.filterValues
                  ),
                },
                Application.config
        );
        this.loading = true;
        try {

          const result = await ajax("/ajax/content/get_products.php", data);


          if (
                  result &&
                  result.result &&
                  result.result === "success" &&
                  result.products
          ) {
            this.products = [...this.products, ...result.products];
            //this.products.value.push(...result.products);
            //this.products = [...result.products];
            this.offset = this.products.length;
            this.shownProducts = this.products.length;
            console.log("Resut",result, this.products );

          }
        }
        finally {
          this.isshowmore=true;
          // Этот блок будет выполнен независимо от успешности или ошибки запроса
          this.loading = false;
        }
      },
      hasFilters(filterValues) {
        if (filterValues.brands) {
          return true;
        }

        if (filterValues.sizes) {
          return true;
        }

        if (filterValues.collections) {
          return true;
        }

        if (filterValues.price) {
          return true;
        }

        if (filterValues.weight) {
          return true;
        }

        if (filterValues.colors) {
          return true;
        }

        if (filterValues.availability) {
          return true;
        }

        for (const key of Object.keys(filterValues)) {
          if (key.startsWith("filter:")) {
            const values = filterValues[key];

            if (values) {
              return true;
            }
          }
        }

        return false;
      },
      generateUrl(filterValues) {
        let result = "";

        if (filterValues.brands) {
          result += "brands/" + filterValues.brands + "/";
        }

        if (filterValues.sizes) {
          result += "sizes/" + filterValues.sizes + "/";
        }

        if (filterValues.collections) {
          result += "collections/" + filterValues.collections + "/";
        }

        if (filterValues.price) {
          result += "price/" + filterValues.price + "/";
        }

        if (filterValues.weight) {
          result += "weight/" + filterValues.weight + "/";
        }

        if (filterValues.colors) {
          result += "colors/" + filterValues.colors + "/";
        }

        if (filterValues.availability) {
          result += "availability/" + filterValues.availability + "/";
        }

        if (filterValues.order) {
          result += "order/" + filterValues.order + "/";
        }

        for (const key of Object.keys(filterValues)) {
          if (key.startsWith("filter:")) {
            const values = filterValues[key];

            if (values) {
              result += key + "/" + values + "/";
            }
          }
        }
        // console.log("apiUrl",this.baseUrl + result, filterValues);
        return this.baseUrl + result;
      },
      getPlainFilterValues(name, staticUrl) {
        const newFilterValues = JSON.parse(JSON.stringify(this.filterValues));
        let values = ((newFilterValues[name] || "").split(",") || []).filter(
                (value) => value
        );

        if (values.includes(staticUrl)) {
          values = values.filter((item) => item != staticUrl);
        } else {
          values.push(staticUrl);
        }

        values.sort();

        if (values.length > 0) {
          newFilterValues[name] = values.join(",");
        } else {
          newFilterValues[name] = undefined;
        }

        return newFilterValues;
      },
      getPlainFilterUrl(name, staticUrl) {
        return this.generateUrl(this.getPlainFilterValues(name, staticUrl));
      },
      setPlainFilterValues(name, staticUrl) {
        this.filterValues = this.getPlainFilterValues(name, staticUrl);
        const url = this.generateUrl(this.filterValues);
        this.updateProducts();
        history.pushState(
                {
                  filterValues: JSON.parse(JSON.stringify(this.filterValues)),
                },
                null,
                url
        );
      },
      isPlainFilterSelected(name, staticUrl) {
        return (
                ((this.filterValues || {})[name] || "").split(",") || []
        ).includes(staticUrl);
      },
      isPlainFilterVisible(name) {
        return (
                (this.filters[name] && this.filters[name].length > 1) ||
                this.isPlainFilterOpen(name)
        );
      },
      isPlainFilterOpen(name) {
        return (
                (((this.filterValues || {})[name] || "").split(",") || []).filter(
                        (value) => value
                ).length > 0
        );
      },
      setRangeFilterValues(name, value) {
        const parsedValue = value.split(",").map((value) => parseFloat(value));

        if (
                parsedValue.length == 2 &&
                (parsedValue[0] != this.filters[name].min ||
                        parsedValue[1] != this.filters[name].max)
        ) {
          this.filterValues[name] = value;
        } else {
          this.filterValues[name] = undefined;
        }

        const url = this.generateUrl(this.filterValues);
        this.updateProducts();
        history.pushState(
                {
                  filterValues: JSON.parse(JSON.stringify(this.filterValues)),
                },
                null,
                url
        );
      },
      isRangeFilterVisible(name) {
        return (
                this.filters[name] &&
                this.filters[name].min &&
                this.filters[name].max &&
                this.filters[name].min !== this.filters[name].max
        );
      },
      isRangeFilterOpen(name) {
        const parsedValue = (
                (this.filterValues || {})[name] ||
                this.filters[name].min + "," + this.filters[name].max
        )
        .split(",")
        .map((value) => parseFloat(value));
        return (
                this.isRangeFilterVisible(name) &&
                (this.filters[name].min != parsedValue[0] ||
                        this.filters[name].max != parsedValue[1])
        );
      },
      setSingleValueFilter(name, value) {
        if (value && value.static_url) {
          this.setSingleValue(name, value.static_url);
        } else {
          this.setSingleValue(name, null);
        }
      },
      setSingleValue(name, value) {
        if (value && value) {
          this.filterValues[name] = value;
        } else {
          this.filterValues[name] = null;
        }

        const url = this.generateUrl(this.filterValues);
        this.updateProducts();
        history.pushState(
                {
                  filterValues: JSON.parse(JSON.stringify(this.filterValues)),
                },
                null,
                url
        );
      },
      toggleSingleValueFilter(name, value) {
        if (this.filterValues[name]) {
          this.filterValues[name] = undefined;
        } else {
          this.filterValues[name] = value;
        }

        const url = this.generateUrl(this.filterValues);
        this.updateProducts();
        history.pushState(
                {
                  filterValues: JSON.parse(JSON.stringify(this.filterValues)),
                },
                null,
                url
        );
      },
      getSingleValueFilter(items, static_url) {
        for (const item of items) {
          if (item.static_url == static_url) {
            return item;
          }
        }

        return null;
      },
    },
    mounted() {
      window.addEventListener("popstate", (event) => {
        if (event.state && event.state.filterValues) {
          this.filterValues = JSON.parse(
                  JSON.stringify(event.state.filterValues)
          );
        }
      });

      window.addEventListener("setorder", (event) => {
        this.setSingleValue("order", event.detail.order);
        this.updateProducts();
      });

      if (this.hasFilters(this.initalFilterValues)) {
        this.$root.openFilters();
      }

    },
  };
</script>

<template>
  <div class="products-page">
    <div class="products-page-content">
      <transition name="fade-03">
        <div v-if="loading" class="loading"></div>
      </transition>
      <slot name="prepend" />
      <slot v-if="!hasFilters(filterValues) && !isshowmore" name="default" />
      <template v-else>
        <div  class="product-tiles"
              :class="{ 'columns-3': $root.isFiltersOpen }"
        >
          <template v-for="product in products"  :key="product.id">
            <div class="product-tile-wrap" >

              <product-tile
                      :product="product"
                      :filter="filterValues"
                      :color-ids="colorGroupIdByUrl"
                      :categurl="baseUrl"
              >
              </product-tile>
            </div>
          </template>
        </div>
      </template>
      <div v-if="totalProducts > 0" class="show-more-block">
        <button
                v-if="shownProducts < totalProducts"
                type="button"
                class="button"
                @click="showMore"
        >
          Показать еще +
        </button>
        <div class="info">
          Показано {{ shownProducts }} из {{ totalProducts }}
        </div>
      </div>
      <div class="page-text-bottom" v-html="bottomText"></div>
    </div>
    <div
            class="products-page-filters-wrap"
            v-bind:class="{ open: $root.isFiltersOpen }"
    >
      <div class="products-page-filters-title">
        <button type="button" @click="$root.closeFilters">
          <icon-arrow-prev /></button
        >Фильтры
      </div>
      <div class="products-page-filters-scroll">
        <div class="products-page-filters">
          <CatalogFliter
                  v-if="isPlainFilterVisible('brands')"
                  :inital-open="isPlainFilterOpen('brands')"
                  :style="{ order: 100 }"
          >
            <template v-slot:title>Бренды</template>
            <div class="filter-tiles">
              <a
                      v-for="brand in filters.brands"
                      :key="brand.id"
                      class="filter-tile"
                      :class="{
                  selected: isPlainFilterSelected('brands', brand.static_url),
                }"
                      :href="getPlainFilterUrl('brands', brand.static_url)"
                      @click.prevent="
                  setPlainFilterValues('brands', brand.static_url)
                "
              >{{ brand.title }}</a
              >
            </div>
          </CatalogFliter>

          <CatalogFliter
                  v-if="isRangeFilterVisible('price')"
                  :inital-open="isRangeFilterOpen('price')"
                  :style="{ order: 200 }"
          >
            <template v-slot:title>Цена, тг</template>
            <range-filter
                    :min="filters.price.min"
                    :max="filters.price.max"
                    :min-step="10"
                    :modelValue="filterValues.price"
                    @update:modelValue="
                (value) => setRangeFilterValues('price', value)
              "
            ></range-filter>
          </CatalogFliter>

          <CatalogFliter
                  v-if="isRangeFilterVisible('weight')"
                  :inital-open="isRangeFilterOpen('weight')"
                  :style="{ order: 300 }"
          >
            <template v-slot:title>Вес, кг</template>
            <RangeFilter
                    :min="filters.weight.min"
                    :max="filters.weight.max"
                    :min-step="0.1"
                    :modelValue="filterValues.weight"
                    @update:modelValue="
                (value) => setRangeFilterValues('weight', value)
              "
            ></RangeFilter>
          </CatalogFliter>

          <!--          <CatalogFliter-->
          <!--            v-if="isPlainFilterVisible('sizes')"-->
          <!--            :inital-open="isPlainFilterOpen('sizes')"-->
          <!--            :style="{ order: 400 }"-->
          <!--          >-->
          <!--            <template v-slot:title>Высота, см</template>-->
          <!--            <div class="filter-tiles">-->
          <!--              <a-->
          <!--                v-for="size in filters.sizes"-->
          <!--                :key="size.id"-->
          <!--                class="filter-tile"-->
          <!--                :class="{-->
          <!--                  selected: isPlainFilterSelected('sizes', size.static_url),-->
          <!--                }"-->
          <!--                :href="getPlainFilterUrl('sizes', size.static_url)"-->
          <!--                @click.prevent="setPlainFilterValues('sizes', size.static_url)"-->
          <!--                >{{ size.title }}</a-->
          <!--              >-->
          <!--            </div>-->
          <!--          </CatalogFliter>-->

          <CatalogFliter
                  v-if="isPlainFilterVisible('colors')"
                  :inital-open="isPlainFilterOpen('colors')"
                  :style="{ order: 500 }"
          >
            <template v-slot:title>Цвета</template>
            <div class="filter-tiles">
              <a
                      v-for="color in filters.colors"
                      :key="color.id"
                      class="filter-tile-color"
                      :class="{
                  selected: isPlainFilterSelected('colors', color.static_url),
                }"
                      :href="getPlainFilterUrl('colors', color.static_url)"
                      @click.prevent="
                  setPlainFilterValues('colors', color.static_url)
                "
              ><span class="tile-block"
              ><span
                      class="tile-color"
                      :style="{
                      backgroundColor: color.color_hex
                        ? color.color_hex
                        : 'transparent',
                      backgroundImage: color.image
                        ? 'url(' + color.image.url + ')'
                        : 'none',
                    }"
              ></span></span
              ><span class="tile-title">{{ color.title }}</span></a
              >
            </div>
          </CatalogFliter>

          <CatalogFliter
                  v-if="isPlainFilterVisible('collections')"
                  :inital-open="isPlainFilterOpen('collections')"
                  :style="{ order: 600 }"
          >
            <template v-slot:title>Коллекция</template>
            <div class="filter-tiles">
              <a
                      v-for="collection in filters.collections"
                      :key="collection.id"
                      class="filter-tile"
                      :class="{
                  selected: isPlainFilterSelected(
                    'collections',
                    collection.static_url
                  ),
                }"
                      :href="getPlainFilterUrl('collections', collection.static_url)"
                      @click.prevent="
                  setPlainFilterValues('collections', collection.static_url)
                "
              >{{ collection.title }}</a
              >
            </div>
          </CatalogFliter>

          <CatalogFliter
                  :inital-open="isPlainFilterOpen('availability')"
                  :style="{ order: 700 }"
          >
            <template v-slot:title>Наличие</template>
            <div class="filter-tiles">
              <button
                      type="button"
                      class="checkbox-button"
                      :class="{ checked: this.filterValues['availability'] }"
                      @click="toggleSingleValueFilter('availability', 'in-stock')"
              >
                В наличии
              </button>
            </div>
          </CatalogFliter>

          <template v-for="filter in filters.custom" :key="filter.id">
            <CatalogFliter
                    :style="{ order: filter.order }"
                    :inital-open="isPlainFilterOpen('filter:' + filter.static_url)"
            >
              <template v-slot:title>{{ filter.title }}</template>
              <template v-if="filter.type == 'multi_choice'">
                <div class="filter-tiles">
                  <a
                          v-for="item in filter.items"
                          :key="item.id"
                          class="filter-tile"
                          :class="{
                      selected: isPlainFilterSelected(
                        'filter:' + filter.static_url,
                        item.static_url
                      ),
                    }"
                          :href="
                      getPlainFilterUrl(
                        'filter:' + filter.static_url,
                        item.static_url
                      )
                    "
                          @click.prevent="
                      setPlainFilterValues(
                        'filter:' + filter.static_url,
                        item.static_url
                      )
                    "
                  >{{ item.title }}</a
                  >
                </div>
              </template>
              <template v-else-if="filter.type == 'multi_choice_picture'">
                <div class="filter-tiles">
                  <a
                          v-for="item in filter.items"
                          :key="item.id"
                          class="filter-tile-image"
                          :class="{
                      selected: isPlainFilterSelected(
                        'filter:' + filter.static_url,
                        item.static_url
                      ),
                    }"
                          :href="
                      getPlainFilterUrl(
                        'filter:' + filter.static_url,
                        item.static_url
                      )
                    "
                          @click.prevent="
                      setPlainFilterValues(
                        'filter:' + filter.static_url,
                        item.static_url
                      )
                    "
                  ><img
                          class="tile-image"
                          :src="(item.image || {}).url"
                  /><span class="tile-title">{{ item.title }}</span></a
                  >
                </div>
              </template>
              <template v-else-if="filter.type == 'select_search'">
                <vue-select
                        class="vue-select"
                        label="title"
                        :options="filter.items"
                        :modelValue="
                    getSingleValueFilter(
                      filter.items,
                      filterValues['filter:' + filter.static_url]
                    )
                  "
                        @update:modelValue="
                    (value) =>
                      setSingleValueFilter('filter:' + filter.static_url, value)
                  "
                >
                  <template v-slot:open-indicator="{ attributes }">
                    <icon-arrow-dropdown
                            v-bind="attributes"
                    ></icon-arrow-dropdown>
                  </template>
                  <template #no-options> Ничего не найдено </template>
                </vue-select>
              </template>
            </CatalogFliter>
          </template>
        </div>
      </div>
      <button type="button" class="close-button" @click="$root.closeFilters">
        Закрыть
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .vue-select {
    margin-bottom: 15px;
  }

  .loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 80;
    background: rgba(255, 255, 255, 0.85);
    overflow: hidden;

    &::before {
      content: "";
      display: block;
      position: absolute;
      width: 70px;
      height: 70px;
      margin: -35px;
      border: 5px solid #000;
      border-right: 5px solid transparent;
      border-bottom: 5px solid transparent;
      box-sizing: border-box;
      border-radius: 100%;
      top: 50%;
      left: 50%;
      animation: spin 0.75s linear infinite;
    }
  }

  .close-button {
    @include black-button;
    height: 50px;
    width: 100%;
  }

  .page-text-bottom {
    margin-top: 25px;
  }
</style>
